(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('advert', function(advertService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            dest: '=', //use :: in the view to stop this reloading all the time
            onPopulate: '&',
            maxToDisplay: '='
        },
        templateUrl: 'partials/home/directivetemplate?type=Advert',
        link(scope, el, attr) {
            const pos = parseInt(attr.position) || 1;

            scope.$watch('dest', function(v) {
                if (v == null) {
                    return;
                }
                init(v);
            });

            function init(dest) {
                if (TRPCONFIG.Domain2.GetSquibsForPositionAPI) {
                    advertService.getAdvertsForPosition(pos, dest).then(function(adverts) {
                        let selection = null;
                        if (scope.maxToDisplay && adverts.length > scope.maxToDisplay) {
                            //randomly return the number requested
                            selection = [];
                            while (selection.length < scope.maxToDisplay) {
                                selection.push(adverts.splice(Math.floor(Math.random() * adverts.length), 1)[0]);
                            }
                        }
                        scope.adverts = selection || adverts;
                        scope.serviceUrl = advertService.getUrl();
                        if (scope.adverts.length) {
                            scope.onPopulate();
                        }
                    });
                }
            }
        }
    };
});
})();
